import { render, staticRenderFns } from "./StatusSelectDialog.vue?vue&type=template&id=271d83ba&"
import script from "./StatusSelectDialog.vue?vue&type=script&lang=js&"
export * from "./StatusSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QSeparator,QList,QItem,QItemSection,QRadio,QItemLabel,QCardActions,QInnerLoading,QSpinner,ClosePopup,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QSeparator,QList,QItem,QItemSection,QRadio,QItemLabel,QCardActions,QInnerLoading,QSpinner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup,Ripple})
